export const HEADER_CONFIG = {
    maxHeight: 30,
    radius: {
        tl: 8, tr: 8, br: 0, bl: 0
    }
};
export const SELECTED_HEADER_STYLE = {
    globalAlpha: 0.05,
    fillStyle: "#4285F4"
};
